export const REPLACE_ACCOUNT_THEME = 'REPLACE_ACCOUNT_THEME';
export const REPLACE_ACCOUNT_THEMES = 'REPLACE_ACCOUNT_THEMES';
export const UPDATE_ACCOUNT_THEME_IN_STORE = 'UPDATE_ACCOUNT_THEME_IN_STORE';
export const UPDATE_ACCOUNT_THEME_AND_FLUSH = 'UPDATE_ACCOUNT_THEME_AND_FLUSH';

export const CREATE_ACCOUNT_THEME = 'CREATE_ACCOUNT_THEME';
export const CLONE_ACCOUNT_THEME = 'CLONE_ACCOUNT_THEME';
export const DELETE_ACCOUNT_THEME = 'DELETE_ACCOUNT_THEME';
export const SET_DEFAULT_THEME = 'SET_DEFAULT_THEME';

export const fonts = [
  { label: 'Arial', value: "Arial, 'Helvetica Neue', Helvetica, sans-serif" },
  { label: 'Arvo', value: "'Arvo', serif" },
  { label: 'Droid Sans', value: "'Droid Sans', sans-serif" },
  { label: 'Futura', value: "Futura, 'Trebuchet MS', Arial, sans-serif" },
  { label: 'Georgia', value: "Georgia, Times, 'Times New Roman', serif" },
  {
    label: 'Helvetica Neue',
    value: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  { label: 'Josefin Slab', value: "'Josefin Slab', serif" },
  { label: 'Lato', value: "'Lato', sans-serif" },
  { label: 'Libre Baskerville', value: "'Libre Baskerville', serif" },
  { label: 'Lucida Bright', value: "'Lucida Bright', Georgia, serif" },
  { label: 'Open Sans', value: "'Open Sans', sans-serif" },
  {
    label: 'Palatino',
    value:
      "Palatino, 'Palatino Linotype', 'Palatino LT STD', 'Book Antiqua', Georgia, serif",
  },
  { label: 'Tahoma', value: 'Tahoma, Verdana, Segoe, sans-serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
];

const percentages = [
  { label: '0%', value: '0' },
  { label: '10%', value: '10' },
  { label: '20%', value: '20' },
  { label: '30%', value: '30' },
  { label: '40%', value: '40' },
  { label: '50%', value: '50' },
  { label: '60%', value: '60' },
  { label: '70%', value: '70' },
  { label: '80%', value: '80' },
  { label: '90%', value: '90' },
  { label: '100%', value: '100' },
];

const nameOptions = [{ name: 'name', type: 'input' }];

const textOptions = [
  {
    label: 'Header font',
    name: 'titleFont',
    type: 'fontdropdown',
    options: fonts,
  },
  {
    label: 'Body font',
    name: 'defaultFont',
    type: 'fontdropdown',
    options: fonts,
  },
  {
    label: 'Default font color',
    name: 'defaultFontColor',
    type: 'textcolorpicker',
  },
];

export const DEFAULT_COMPONENT_WIDTH = `168px`;
export const DEFAULT_COMPONENT_MARGIN_TOP = `16px`;
export const DEFAULT_FONT_SIZE = '14px';
export const PRIMARY_BORDER = 'primaryBorder';
export const SECONDARY_BORDER = 'secondaryBorder';
export const PRIMARY_BORDER_COLOR = 'primaryBorderColor';
export const SECONDARY_BORDER_COLOR = 'secondaryBorderColor';
export const PRIMARY_BORDER_WIDTH = 'primaryBorderWidth';
export const SECONDARY_BORDER_WIDTH = 'secondaryBorderWidth';
export const PRIMARY_HOVER_BORDER = 'primaryHoverBorder';
export const SECONDARY_HOVER_BORDER = 'secondaryHoverBorder';
export const PRIMARY_HOVER_BORDER_COLOR = 'primaryHoverBorderColor';
export const SECONDARY_HOVER_BORDER_COLOR = 'secondaryHoverBorderColor';
export const PRIMARY_HOVER_BORDER_WIDTH = 'primaryHoverBorderWidth';
export const SECONDARY_HOVER_BORDER_WIDTH = 'secondaryHoverBorderWidth';

export const HOVER_PROPERTIES = new Set([
  PRIMARY_HOVER_BORDER,
  SECONDARY_HOVER_BORDER,
  PRIMARY_HOVER_BORDER_COLOR,
  SECONDARY_HOVER_BORDER_COLOR,
  PRIMARY_HOVER_BORDER_WIDTH,
  SECONDARY_HOVER_BORDER_WIDTH,
]);

const buttonsOptions = [
  {
    category: 'all',
    fields: [
      {
        label: 'Font size',
        name: 'buttonFontSize',
        type: 'inputwithsuffix',
      },
      {
        label: 'Corner radius',
        name: 'cornerRadius',
        type: 'slider-cornerRadius',
      },
    ],
  },
  {
    category: 'primary',
    fields: [
      {
        label: 'Background color',
        name: 'primaryColor',
        type: 'backgroundcolorpicker',
      },
      {
        label: 'Border color',
        name: PRIMARY_BORDER,
        type: 'borderColor',
      },
      {
        label: 'Font color',
        name: 'buttonTextColor',
        type: 'textcolorpicker',
      },
      {
        label: 'Hover color',
        name: 'hoverPrimaryColor',
        type: 'backgroundcolorpicker',
      },
      {
        label: 'Hover border color',
        name: PRIMARY_HOVER_BORDER,
        type: 'borderColor',
      },
      {
        label: 'Hover font color',
        name: 'buttonTextSecondaryColor',
        type: 'textcolorpicker',
      },
    ],
  },
  {
    category: 'secondary',
    fields: [
      {
        label: 'Background color',
        name: 'secondaryColor',
        type: 'backgroundcolorpicker',
      },
      {
        label: 'Border color',
        name: SECONDARY_BORDER,
        type: 'borderColor',
      },
      {
        label: 'Font color',
        name: 'secondaryButtonTextColor',
        type: 'textcolorpicker',
      },
      {
        label: 'Hover color',
        name: 'hoverSecondaryColor',
        type: 'backgroundcolorpicker',
      },
      {
        label: 'Hover border color',
        name: SECONDARY_HOVER_BORDER,
        type: 'borderColor',
      },
      {
        label: 'Hover font color',
        name: 'secondaryButtonTextSecondaryColor', // im sorry
        type: 'textcolorpicker',
      },
    ],
  },
];

export const modalsAndSlideoutsOptions = [
  {
    label: 'Font color',
    name: 'modalTextColor',
    type: 'textcolorpicker',
  },
  {
    label: 'Background color',
    name: 'modalBackgroundColor',
    type: 'backgroundcolorpicker',
  },
  {
    label: 'Backdrop color',
    name: 'maskColor',
    type: 'backgroundcolorpicker',
  },
  {
    label: 'Backdrop opacity',
    name: 'maskOpacity',
    type: 'slider-opacity',
    options: percentages,
  },
];

export const hotspotsAndTooltipsOptions = [
  {
    label: 'Font color',
    name: 'tooltipTextColor',
    type: 'textcolorpicker',
  },
  {
    label: 'Background color',
    name: 'tooltipColor',
    type: 'backgroundcolorpicker',
  },
  {
    label: 'Border radius',
    name: 'tooltipRadius',
    type: 'slider-px',
    options: percentages,
  },
  {
    label: 'Shadow',
    name: 'tooltipShadow',
    type: 'dropdown',
    options: [
      { label: 'Solid', value: 'solid' },
      { label: 'Blur', value: 'blur' },
      { label: 'None', value: 'none' },
    ],
  },
  {
    label: 'Beacon icon',
    name: 'beaconStyle',
    type: 'dropdown',
    options: [
      { label: 'Hotspot', value: 'hotspot' }, // hideBeacon: false
      { label: 'Question Mark', value: 'question' }, // hideBeacon: false
      { label: 'None', value: 'none' }, // hideBeacon: true
    ],
  },
  {
    label: 'Beacon color',
    name: 'beaconColor',
    type: 'backgroundcolorpicker',
  },
  {
    label: 'Beacon animation',
    name: 'hotspotAnimation',
    type: 'dropdown',
    options: [
      { label: 'Pulse', value: 'hotspot-animation-pulse' },
      { label: 'None', value: 'none' },
    ],
  },
];

export const generalSections = [
  { title: 'name', options: nameOptions },
  { title: 'text', options: textOptions },
];

export const buttonSections = [{ title: 'buttons', options: buttonsOptions }];

export const patternsSections = [
  { title: 'modals & slideouts', options: modalsAndSlideoutsOptions },
  { title: 'hotspots & tooltips', options: hotspotsAndTooltipsOptions },
];

export const modalPreviewContent = {
  version_id: 1,
  type: 'modal',
  redirect_url: null,
  redirect_new_tab: false,
  next_content_id: null,
  name: 'Demo Modal',
  id: '-LmjW15_spyZpOJR4qZ_',
  attributes: {
    pattern_type: 'modal',
    backdrop: true,
    skippable: true,
    style: null,
    steps: [
      {
        id: '-LmjW15_spyZpOJR4qZa',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:140px;background-size:100%;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1568313849/21258/rkcdg9cp744skak6itzu.jpg);"><div class="hero-content"><h3></h3></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:12px;margin-bottom:-8px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center">Heading 2</h2><p style="text-align:center">This is standard paragraph text, where you can describe things in more detail. You can <strong>bold your text</strong>, <em>italicize it</em>, or <a style="color:" href="https://www.appcues.com" target="_blank">add links</a>!</p></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: 'See more components...',
        step_number: 1,
        step_buttons: [
          {
            type: 'NEXT',
            align: 'RIGHT',
            text: 'See more components...',
          },
          {
            type: 'BACK',
            align: 'LEFT',
            text: 'Back',
          },
        ],
        is_button_centered: true,
      },
      {
        id: '-LmjWwoX0HC0EP-KnRUl',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:left">Heading 2</h2></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:left;margin-top:8px;"><img src="//twemoji.maxcdn.com/2/svg/1f386.svg" style=" width: 32px" alt="Fireworks emoji"/></div> </div> </div> </div> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:left;margin-top:8px;"><img src="//twemoji.maxcdn.com/2/svg/1f35e.svg" style=" width: 32px" alt="Bread emoji"/></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:16px;"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:start"><span style="color:rgb(72, 68, 68)"><strong>Appcues ideas:</strong></span></p><ul><li><span style="color:rgb(72, 68, 68)">Help beginners get started</span></li><li><span style="color:rgb(72, 68, 68)">Point out a new feature</span></li><li><span style="color:rgb(72, 68, 68)">Get user feedback</span></li></ul></div></div> </div> </div> </div> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:16px;"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:start"><span style="color:rgb(72, 68, 68)"><strong>Winter snowstorm shopping list:</strong></span></p><ol><li><span style="color:rgb(72, 68, 68)">Eggs</span></li><li><span style="color:rgb(72, 68, 68)">Milk</span></li><li><span style="color:rgb(72, 68, 68)">Bread</span></li></ol></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: 'Form components',
        step_number: 2,
        step_buttons: [],
        next_button_hidden: false,
        prev_button_hidden: false,
        actions_hidden: false,
        is_button_centered: false,
      },
      {
        id: '-LmjXJ1bMb1uVPoJim5q',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h2>Appcues forms</h2></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <form class="step-action-form" style="marginTop:-8px;marginBottom:-8px;"><div class="fields"><div class="field" data-field-id="ae17a2c9-33f0-4488-aea9-c77b8115cf74"><div class="form-field form-field-radio" style="marginTop: 0; padding: 0;" data-appcues-required="false"><div class="field-label"><label class="label-display" for="ae17a2c9-33f0-4488-aea9-c77b8115cf74">Rating</label></div><div class="field-controls"><div class="rating-options"><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="0"/><span>0</span></label><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="1"/><span>1</span></label><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="2"/><span>2</span></label><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="3"/><span>3</span></label><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="4"/><span>4</span></label><label class="rating-option"><input class="response-value" type="radio" name="ae17a2c9-33f0-4488-aea9-c77b8115cf74" value="5"/><span>5</span></label></div><div class="rating-labels row"><div class="col-md-6 left"><small class="text-muted">Low</small></div><div class="col-md-6 right text-right"><small class="text-muted">High</small></div></div></div></div></div></div></form> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <form class="step-action-form" style=""><div class="fields"><div class="field" data-field-id="a84e9b50-8cd1-4bd8-9d7e-f48147e23487"><div class="form-field form-field-radio" style="marginTop: 0; padding: 0;" data-appcues-required="false"><div class="field-label"><label class="label-display" for="a84e9b50-8cd1-4bd8-9d7e-f48147e23487">Select an option:</label></div><div class="field-controls"><div class="field-options"><label class="field-option"><input type="radio" class="response-value" name="a84e9b50-8cd1-4bd8-9d7e-f48147e23487" value="Dogs"/><span>Dogs</span></label><label class="field-option"><input type="radio" class="response-value" name="a84e9b50-8cd1-4bd8-9d7e-f48147e23487" value="Cats"/><span>Cats</span></label></div></div></div></div></div></form> </div> </div> </div> <div class="zone-container" style="display: inline-block; width: 50%; float: left;"> <div class="zone"> <div class="zone-content"> <form class="step-action-form" style=""><div class="fields"><div class="field" data-field-id="df5517b9-d7be-46c3-8e86-bbe5fbde6846"><div class="form-field form-field-text" style="marginTop: 0; padding: 0;" data-appcues-validation="null" data-appcues-required="false"><div class="field-label"><label class="label-display" for="df5517b9-d7be-46c3-8e86-bbe5fbde6846">What\'s your favorite color?</label></div><div class="field-controls"><input type="text" class="form-control" data-field-id="df5517b9-d7be-46c3-8e86-bbe5fbde6846" placeholder="Enter a color name..."/></div></div></div></div></form> </div> </div> </div> </div> </div> </div>',
        next_text: 'Images and video',
        step_number: 3,
        step_buttons: [],
        prev_button_hidden: false,
        actions_hidden: false,
        is_button_centered: false,
      },
      {
        id: '-Lmjf97QoqTrvLsHsnBE',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center"><span style="color:rgb(72, 68, 68)">You can add images and embed video too!</span></h2></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:center;"><img src="//res.cloudinary.com/dnjrorsut/image/upload/v1568384609/21258/sgnz9ojq5gsmpuemi4pd.png" style=" width: 120px"/></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:left">Try animated gifs, free illustrations from <a style="color:" href="https://undraw.co/illustrations" target="_blank">Undraw.co</a>,  images from <a style="color:" href="https://unsplash.com/" target="_blank">Unsplash</a>, training videos, or webinars.</p></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: "That's all folks!",
        step_number: 4,
        step_buttons: [],
        next_button_hidden: false,
        prev_button_hidden: false,
        actions_hidden: false,
        is_button_centered: false,
      },
    ],
  },
};

export const tooltipPreviewContent = {
  version_id: 1,
  type: 'hotspot-group',
  redirect_url: null,
  redirect_new_tab: false,
  next_content_id: null,
  name: 'Demo Annotations',
  id: '-LmjjIQxTt8CDMEJj36m',
  attributes: {
    sequential: true,
    skippable: true,
    style: null,
    hotspots: [
      {
        id: '-LmjjIQyN3M8NpntQkaG',
        index: 1,
        selector: 'body',
        offset_x_percentage: '0.5',
        offset_y_percentage: '0.85',
        backdrop_solid_edge_border_radius: 300,
        backdrop_solid_edge_x_padding: 0,
        backdrop_solid_edge_y_padding: 0,
        tooltip_alignment: null,
        pattern: 'beacon',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:center;margin-top:8px;margin-bottom:12px;"><img src="//twemoji.maxcdn.com/2/svg/2764.svg" style=" width: 32px"/></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h4 style="text-align:center">Heading 4</h4></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:center">Tooltip or hotspot body text.</p></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: '',
        hide_next_button: true,
        skip_text: '',
        ui_conditions: {
          next: {
            params: {
              event: 'click',
              selector: [
                {
                  selector: '[onclick]',
                },
              ],
            },
            type: 'WAIT_FOR_MOUSE_EVENT',
          },
        },
      },
    ],
  },
};

export const slideoutPreviewContent = {
  version_id: 1,
  type: 'modal',
  redirect_url: null,
  redirect_new_tab: false,
  next_content_id: null,
  name: 'Demo Modal',
  id: '-LmjjdQwP3zD-LJKQc6l',
  attributes: {
    pattern_type: 'shorty',
    position: 'bottom',
    backdrop: false,
    skippable: true,
    style: null,
    steps: [
      {
        id: '-LmjjdQwP3zD-LJKQc6m',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:center;margin-top:8px;margin-bottom:6px;"><img src="//res.cloudinary.com/dnjrorsut/image/upload/v1568315933/21258/iwxmu06xnal4q5gtduft.png" style=" width: 120px"/></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h1 style="text-align:center">Heading 1</h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:center">Main body text.</p></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: "Let's go!",
        step_number: 1,
        step_buttons: [],
        is_button_centered: true,
      },
      {
        id: '-Lmjk1Vcgpr2DendRy-A',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:100px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1513187203/crx-assets/modal-slideout-hero-image.png);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center">Heading 2</h2><p style="text-align:center">Slideouts are smaller dialogs.</p></div></div> </div> </div> </div> </div> </div> </div>',
        next_text: 'Let’s go!',
        step_number: 2,
        step_buttons: [
          {
            type: 'NEXT',
            align: 'RIGHT',
            text: 'Ok, got it',
          },
          {
            type: 'BACK',
            align: 'LEFT',
            text: 'Back',
          },
        ],
        prev_button_hidden: false,
        actions_hidden: false,
        is_button_centered: false,
      },
      {
        id: '-LmjkbfChk7DJ2yC1QxL',
        html: '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h3>Heading 3</h3></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <form class="step-action-form" style=""><div class="fields"><div class="field" data-field-id="de6bfe87-da33-47a2-88ff-ee5dfd318dcd"><div class="form-field form-field-radio" style="marginTop: 0; padding: 0;" data-appcues-required="true"><div class="field-label"><label class="label-display" for="de6bfe87-da33-47a2-88ff-ee5dfd318dcd">* Slideouts are great for quick surveys</label></div><div class="field-controls"><div class="rating-options"><label class="rating-option"><input class="response-value" type="radio" name="de6bfe87-da33-47a2-88ff-ee5dfd318dcd" value="0"/><span>0</span></label><label class="rating-option"><input class="response-value" type="radio" name="de6bfe87-da33-47a2-88ff-ee5dfd318dcd" value="1"/><span>1</span></label><label class="rating-option"><input class="response-value" type="radio" name="de6bfe87-da33-47a2-88ff-ee5dfd318dcd" value="2"/><span>2</span></label><label class="rating-option"><input class="response-value" type="radio" name="de6bfe87-da33-47a2-88ff-ee5dfd318dcd" value="3"/><span>3</span></label><label class="rating-option"><input class="response-value" type="radio" name="de6bfe87-da33-47a2-88ff-ee5dfd318dcd" value="4"/><span>4</span></label></div><div class="rating-labels row"><div class="col-md-6 left"><small class="text-muted">I don\'t like it</small></div><div class="col-md-6 right text-right"><small class="text-muted">I love it!</small></div></div></div></div></div></div></form> </div> </div> </div> </div> </div> </div>',
        next_text: "That's all!",
        step_number: 3,
        step_buttons: [],
        prev_button_hidden: false,
        actions_hidden: false,
        is_button_centered: false,
      },
    ],
  },
};

export const stylePageCss = `
  appcues>.appcues-skip, appcues>.appcues-progress, appcues>cue {
    max-width: 90%;
  }
  appcues>cue {
    min-height: 300px;
  }
  appcues {
    overflow: hidden;
  }
  appcues .appcues-skip a, .appcues-backdrop[data-pattern-type=left], .appcues-backdrop[data-pattern-type=modal] {
    pointer-events: none !important;
  }
`;
